module.exports = __webpack_public_path__ + "assets/share-edit-list.a61fcb07.svg";